import React from 'react'
import { Label, Paragraph, SmallText } from '@entur/typography'
import { colors } from '@entur/tokens'
import { SensitiveInfo } from '../sensitive-info/sensitive-info'
import { SimpleRule } from '../../api-clients/api-types'
import { useClientInfo } from '../../contexts/client-info-context'

type RuleElementProps = {
  displayLabel?: boolean
  createdByRule?: SimpleRule
}

export const RuleElement: React.FC<RuleElementProps> = ({ createdByRule, displayLabel = true }) => {
  const { hasSensitiveAccess } = useClientInfo()

  return hasSensitiveAccess ? (
    <>
      {!displayLabel || <Label>Regel</Label>}
      <Paragraph style={{ marginBottom: 0 }}>
        {createdByRule?.name || <SmallText style={{ color: colors.blues.blue40 }}>-Ingen regel-</SmallText>}
      </Paragraph>
    </>
  ) : (
    <SensitiveInfo
      field={{ fieldName: 'rule', displayName: 'Regel', displayValue: '', value: '' }}
      displayLabel={displayLabel}
    />
  )
}
